import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class InputUserRelation<T extends EMode = EMode.entity> {
  /** Alias: add */
  add?: number[];
  /** Alias: remove */
  remove?: number[];

  __typename?: string;
}

const fields: FieldDefinitions<InputUserRelation> = {
  add: {
    alias: 'add',
  },
  remove: {
    alias: 'remove',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputUserRelationEntityDefinition: EntitiyDefinition<InputUserRelation> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputUserRelation',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
